import React from 'react';
import { Card, Space, Typography, Button } from 'antd';
import { CheckCircleFilled, EditOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import './CompletedStepCard.css';

interface CompletedIdentifyCardProps {
    email?: string;
    phone?: string;
    onEdit?: () => void;
}

export const CompletedIdentifyCard: React.FC<CompletedIdentifyCardProps> = ({
    email,
    phone,
    onEdit,
}) => {
    return (
        <Card className="completed-step-card" size="small">
            <div className="completed-step-card__header">
                <Space className="completed-step-card__title" align="center">
                    <CheckCircleFilled className="completed-step-card__check" />
                    <Typography.Text strong>Identificación</Typography.Text>
                </Space>
                {onEdit && (
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={onEdit}
                        className="completed-step-card__edit"
                    >
                        Editar
                    </Button>
                )}
            </div>
            <div className="completed-step-card__content">
                {email && (
                    <div className="completed-step-card__item">
                        <Space size={8} align="center">
                            <MailOutlined className="completed-step-card__icon" />
                            <Typography.Text type="secondary">{email}</Typography.Text>
                        </Space>
                    </div>
                )}
                {phone && (
                    <div className="completed-step-card__item">
                        <Space size={8} align="center">
                            <PhoneOutlined className="completed-step-card__icon" />
                            <Typography.Text type="secondary">{phone}</Typography.Text>
                        </Space>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default CompletedIdentifyCard;
